export default "__VITE_ASSET__b5b96e80__"